import { take, put, call, fork } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { REQUESTED_APPLICATION_LIST } from "../actions/types"

import { requestAppListSuccess, requestAppListError } from "../actions/creators"

const { REACT_APP_APPLICATIONS_REST_API } = env

function* request() {
  try {
    const response = yield call(authRequest, {
      url: REACT_APP_APPLICATIONS_REST_API,
    })

    yield put(requestAppListSuccess(response))
  } catch (error) {
    yield put(requestAppListError(error))
  }
}

export default function* requestSaga() {
  while (true) {
    const action = yield take(REQUESTED_APPLICATION_LIST)
    yield fork(request, action)
  }
}
